const getPhraseFromTextfieldName = (name) => {
  const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
  const map = {
    firstname: "First Name",
    lastname: "Last Name",
    eligibility_number: "Eligibility Number",
    eligibility_id: "Eligibility ID",
    company_id_number: "Company ID Number",
    registrant_name: "Registrant Name",
    card_cvv: "Card CVV"
  }

  const mapTextname = (str) => {
    const isFound = Object.keys(map).find(key=>{
      return (str.indexOf(key)>-1)
    })
    if(isFound){
      return map[isFound]
    }
    return false
  }
  const found = mapTextname(name.toLowerCase())
  if(found){
    return found
  }
  const string = name.split('_').join(' ');
  return titleCase(string)
}

export const emailFieldValidation = value =>
  value && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const requiredFieldValidation = (value,allValues,form,name) => {
  const phrase = getPhraseFromTextfieldName(name)
  return value && /^(?!\s*$).+$/i.test(value) ? undefined : `${phrase?phrase+' required':'Required'}`
}

export const domainnameFieldValidation = value =>
  //value && /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/i.test(value)
  value && /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}(?:\.[a-zA-Z]{2,})+$/i.test(value)
    ? undefined
    : 'Invalid Domain Name'

export const creditcardValidation = (value) => {
  if (value) {
    value = value.split(' ').join('')
  }
  return value && /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/i.test(value)
    ? undefined
    : 'Invalid Credit Card'
}

export const creditcardDateValidation = (value) => {
  var result = false
  value = value.split('/')
  var pattern = /^\d{2}$/

  if (value[0] < 1 || value[0] > 12)
    result = true

  if (!pattern.test(value[0]) || !pattern.test(value[1]))
    result = true

  if (value[2])
    result = true

  return result ? 'Invalid Date. The format must be: mm/yy' : undefined
}

export const creditcardTypeValidation = (value) => {
  return value ? undefined : 'Invalid Card Number'
}

export const passwordValidation = value => {
  const errors = {
    characterlimit: false,
    oneuppercase: false,
    onesymbol: false
  }
  //needs to be eight characters
  if (!value || value.length < 8) {
    errors.characterlimit = false
  } else {
    errors.characterlimit = true
  }
  //needs to have one uppercase
  const pattern1 = new RegExp('^(?=.*[a-z])(?=.*[A-Z]).*$')
  if (value && pattern1.test(value)) {
    errors.oneuppercase = true
  } else {
    errors.oneuppercase = false
  }
  //needs to have one symbol or number
  const pattern2 = new RegExp('(?=.*[/_/-/*@#$%^&+=])|(?=.*[0-9]).*$')
  if (value && pattern2.test(value)) {
    errors.onesymbol = true
  } else {
    errors.onesymbol = false
  }

  let isValid = true
  for (var p in errors) {
    if (errors[p] === false) {
      isValid = false
    }
  }
  return isValid === true ? undefined : 'Weak password. 8 or more characters, At least 1 uppercase and lowercase character, and At least 1 number or special character (e.g !@$%) '
}

export const phonenumberValidation = value => {
  const phoneno = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
  if (value.match(phoneno)) {
    return undefined
  }
  return 'Phone number is invalid'
}

const regexAU = /^\({0,1}((0|\+?61)(2|4|3|7|8)){0,1}\){0,1}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{1}( |-){0,1}[0-9]{3}$/
const regexNZ = /^(((\+?64\s*[-.]?[3-9]|\(?0[3-9]\)?)\s*[-.]?\d{3}\s*[-.]?\d{4})|((\+?64\s*[-.(]?2\d{1}[-.)]?|\(?02\d{1}\)?)\s*[-.]?\d{3}\s*[-.]?\d{3,5})|((\+?64\s*[-.]?[-.(]?800[-.)]?|[-.(]?0800[-.)]?)\s*[-.]?\d{3}\s*[-.]?(\d{2}|\d{5})))$/

export const AU_NZ_phone_validation = value => {

  const input = value.split(' ').join('')
  if (input.match(regexAU) || input.match(regexNZ)) {
    return undefined
  }
  return 'It needs to be AU or NZ phone number'
}

export const getInitialCountryValue = () => {
  const createAccount = localStorage.getItem('createAccount')
  if (createAccount && JSON.parse(createAccount)) {
    const { phone } = JSON.parse(createAccount)
    const input = phone.split(' ').join('')
    if (input.match(regexAU)) {
      return 'AU'
    }
    if (input.match(regexNZ)) {
      return 'NZ'
    }
  }
  return 'AU'
}

export const countryFieldValidation = (value) => {
  const createAccount = localStorage.getItem('createAccount')
  let phoneType = 'AU'
  let au_flag = false
  let nz_flag = false
  if (createAccount && JSON.parse(createAccount)) {
    const { phone } = JSON.parse(createAccount)
    const input = phone.split(' ').join('')
    if (input && input.match(regexAU)) {
      phoneType = 'AU'
      au_flag = true
    }
    if (input && input.match(regexNZ)) {
      phoneType = 'NZ'
      nz_flag = true
    }
  }
  if (nz_flag && au_flag) {
    return undefined
  }
  if (value !== phoneType) {
    return `Country needs to match the phone no (${phoneType})`
  }
  return undefined
}


export const nameFieldValidation = value => {
  return /\d/.test(value) ? 'Invalid name' :  undefined;
}